
import { getCustomFieldOptions, getStaticOptions } from '@/utils/helpers'
import { ICustomFieldFormData } from '@/utils/types'
import { Options, Vue } from 'vue-class-component'
import { InjectReactive, Prop, PropSync } from 'vue-property-decorator'
interface IFieldOption {
  label: string
  value: string
}

@Options({
  components: {},
  emits: ['update:modelValue'],
  name: 'ActivationDataSyntaxSelectBox',
})
export default class ActivationDataSyntaxSelectBox extends Vue {
  @InjectReactive() customFields!: ICustomFieldFormData[]
  @PropSync('modelValue', { type: String, default: '' }) readonly syncedModelValue!: string
  @Prop({ default: true }) readonly disabled?: boolean
  @Prop({ default: [] }) readonly excludedFieldType: string[] = []

  get customFieldOptions(): IFieldOption[] {
    const options = getStaticOptions()
    const customField = getCustomFieldOptions({ fields: this.customFields, excludeFieldType: this.excludedFieldType })
    options.push(...customField)
    return options
  }
}
